<template>
  <div class="journal-warpper">
    <div class="flex align-top justify-between">
      <div class="flex-sub margin-right">
        <div class="flex align-center justify-between margin-bottom-xs">
          <div class="flex align-center margin-right-sm basis-smf">
            <span>修改时间：</span>
            <el-date-picker
                class="margin-right-sm flex-sub"
                v-model="dateArr"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
          <div class="flex align-center margin-right-sm basis-smf">
            <span>修改板块：</span>
            <el-select v-model="modular" placeholder="请选择" class="flex-sub">
              <el-option
                  v-for="item in modularList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="flex align-center margin-right-sm basis-smf">
            <span>修改人：</span>
            <el-select v-model="personnel" placeholder="请选择" class="flex-sub">
              <el-option
                  v-for="item in personnelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <fiveLevel @upFive="upFive"/>
      </div>
      <div>
        <div class="margin-bottom-xs"><el-button type="primary" @click="hanldSearch">搜索</el-button></div>
          <div><el-button type="primary" @click="exportList">导出</el-button></div>
      </div>

    </div>
    <el-table
        :data="journalList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
    >
      <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
      <el-table-column label="修改日期" prop="create_time"></el-table-column>
      <el-table-column label="修改人" prop="admin_name"></el-table-column>
      <el-table-column label="修改栏目" prop="lanmu_name"></el-table-column>
      <el-table-column label="修改房屋" prop="name">
        <template slot-scope="scope">
          <div class="table-operate">
            {{scope.row.building_name}}-{{scope.row.element_name}}-{{scope.row.room_name}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="修改内容" prop="msg" width="500"></el-table-column>

    </el-table>
    <el-pagination
        v-if="journalList.length > 0"
        class="page-all"
        background
        @current-change="getJournalList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import {modular, zhDate} from '@/utils/utils'
import fiveLevel from '@/components/five-level'
import {getXiuGaiRen, webLogExport, webLogList} from "@/api/statistics";

export default {
  name: "journal",
  data() {
    return {
      personnelList: [{id: 0, name: '全部'}],
      dateArr: null,
      modular: 0,
      personnel: 0,
      project: 0,
      community: 0,
      building: 0,
      unit: 0,
      room: 0,
      page: 1,
      limit: 10,
      total: 0,
      journalList: [],
    }
  },
  created() {
    this.getXiuGaiRen()
    this.getJournalList()
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    modularList() {
      const power = this.user.power
      console.log(power)
      let _arr = [{value: 0, label: '全部'}]
      modular.map(item => {
        if (item.power.indexOf(power) !== -1) _arr.push(item)
      })
      return _arr
    }
  },
  components: {
    fiveLevel
  },
  methods: {
    async exportList(){
      let _state = await webLogExport(
        this.dateArr ? zhDate(this.dateArr[0]) + ' 00:00:00' : '',
        this.dateArr ? zhDate(this.dateArr[1]) + ' 23:59:59' : '',
        this.modular,
        this.personnel,
        this.project,
        this.community,
        this.building,
        this.unit,
        this.room,
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', '综合改造信息.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getJournalList()
    },
    //  获取日志列表
    async getJournalList() {
      let _list = await webLogList(
          this.dateArr ? zhDate(this.dateArr[0]) + ' 00:00:00' : '',
          this.dateArr ? zhDate(this.dateArr[1]) + ' 23:59:59' : '',
          this.modular,
          this.personnel,
          this.project,
          this.community,
          this.building,
          this.unit,
          this.room,
          this.page,
          this.limit
      )
      _list.data.map(item=>{
        item.create_time = zhDate(item.create_time*1000,1)
      })
      this.journalList = _list.data
      this.total = _list.total_number
    },
    //  获取修改人
    async getXiuGaiRen() {
      let _list = await getXiuGaiRen()
      this.personnelList = [...this.personnelList, ..._list.data]
    },
    //  同步更新五级联动
    upFive(val) {
      this.project = val.project
      this.community = val.community
      this.building = val.building
      this.unit = val.unit
      this.room = val.room
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
